import React from "react";
export const InfoCircleSVG = ({ fillColor = "", strokeWidth = 0 }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      overflow="visible" xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M8.5 15C6.64348 15 4.86301 14.2625 3.55025 12.9497C2.2375 11.637 1.5 9.85652 1.5 8C1.5 6.14348 2.2375 4.36301 3.55025 3.05025C4.86301 1.7375 6.64348 1 8.5 1C10.3565 1 12.137 1.7375 13.4497 3.05025C14.7625 4.36301 15.5 6.14348 15.5 8C15.5 9.85652 14.7625 11.637 13.4497 12.9497C12.137 14.2625 10.3565 15 8.5 15ZM8.5 16C10.6217 16 12.6566 15.1571 14.1569 13.6569C15.6571 12.1566 16.5 10.1217 16.5 8C16.5 5.87827 15.6571 3.84344 14.1569 2.34315C12.6566 0.842855 10.6217 0 8.5 0C6.37827 0 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16Z"
          fill={fillColor || undefined} stroke={fillColor || undefined} className={fillColor ? undefined : "fill-brand stroke-brand"} strokeWidth={strokeWidth} strokeLinejoin="round"
        />
        <path
          d="M9.43 6.588L7.14 6.875L7.058 7.255L7.508 7.338C7.802 7.408 7.86 7.514 7.796 7.807L7.058 11.275C6.864 12.172 7.163 12.594 7.866 12.594C8.411 12.594 9.044 12.342 9.331 11.996L9.419 11.58C9.219 11.756 8.927 11.826 8.733 11.826C8.458 11.826 8.358 11.633 8.429 11.293L9.43 6.588ZM9.5 4.5C9.5 4.76522 9.39464 5.01957 9.20711 5.20711C9.01957 5.39464 8.76522 5.5 8.5 5.5C8.23478 5.5 7.98043 5.39464 7.79289 5.20711C7.60536 5.01957 7.5 4.76522 7.5 4.5C7.5 4.23478 7.60536 3.98043 7.79289 3.79289C7.98043 3.60536 8.23478 3.5 8.5 3.5C8.76522 3.5 9.01957 3.60536 9.20711 3.79289C9.39464 3.98043 9.5 4.23478 9.5 4.5Z"
          fill={fillColor || undefined} stroke={fillColor || undefined} className={fillColor ? undefined : "fill-brand stroke-brand"} strokeWidth={strokeWidth} strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
